import React from 'react';

import Icon from 'shared/components/Icon';

import './styles.scss';

const BadgeComponent = ({ icon, title, backgroundColor }) => {
  const styles = {
    backgroundColor,
  };
  return (
    <div className="badge" style={styles}>
      <Icon icon={icon} className="badge-icon" />
      <span>{title}</span>
    </div>
  );
};

export default BadgeComponent;
